import axios from "axios";

export const deudasService = {
  async getDeuda({ recurso, imponible }) {
    try {
      let response = await axios.get(`https://wsrfa.sannicolasciudad.gob.ar/consultas/deudaCC.php?recurso=${recurso}&imponible=${imponible}&concepto=0`);
      
      return response;
    }
    catch (err) {
      return err.message;
    }
  },

  async getImponibles({ abogado }) {
    try {
      let response = await axios.get(`https://wsrfa.sannicolasciudad.gob.ar/consultas/recImpxAbog.php?abogado=${abogado}`);

      return response;
    }
    catch (err) {
      return err.message;
    }
  },

  async comercioxInmueble(inm) {
    try {
      let response = await axios.get(`https://wsrfa.sannicolasciudad.gob.ar/consultas/comercioxInmueble.php?inm=${inm}`);

      return response;
    }
    catch (err) {
      return err.message;
    }
  },

  async comercioxCC(cc) {
    try {
      let response = await axios.get(`https://wsrfa.sannicolasciudad.gob.ar/comercio/comerciosxCC.php?cc=${cc}`);

      return response;
    }
    catch (err) {
      return err.message;
    }
  },

  async existeComercio(com) {
    try {
      let response = await axios.get(`https://wsrfa.sannicolasciudad.gob.ar/consultas/existeComercio.php?com=${com}`);

      return response;
    }
    catch (err) {
      return err.message;
    }
  },

  async listaSituaciones(data) {
    try {
      let response = await axios.post("https://wsrfa.sannicolasciudad.gob.ar/cobrojud/listaSituaciones.php", { data });

      return response.data;
    }
    catch (err) {
      return err.message;
    }
  },

  async listaSitua(data) {
    try {
      // let response = await axios.post("https://wsrfa.sannicolasciudad.gob.ar/cobrojud/listaSitua.php", { data });
      // let response = await axios.post("https://wsrfa.sannicolasciudad.gob.ar/cobrojud/listaSituaTest.php", { data });
      let response = await axios.post("https://wsrfa.sannicolasciudad.gob.ar/cobrojud/listaSituaV2.php", { data });

      return response.data;
    }
    catch (err) {
      return err.message;
    }
  },

  async listaSituaActual(data) {
    try {
      let response = await axios.post("https://wsrfa.sannicolasciudad.gob.ar/cobrojud/listaSituaActual.php", { data });

      return response.data;
    }
    catch (err) {
      return err.message;
    }
  }
};